import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CARETAKERS = [
  {
    name: "Kylen Blom",
    role: "Caretaker",
    img: "/wayside/kylen.jpg",
    bio: "Tends the trees, the hives, and most everything in between — happiest with soil on his hands and a season ahead.",
  },
  {
    name: "Jaime Blom",
    role: "Caretaker",
    img: "/wayside/jaime.jpg",
    bio: "Keeps the orchard's heart beating — from the kitchen and the boiling pans to the stories we love to share.",
  },
  {
    name: "Watson & Sheldon",
    role: "Fertilizers",
    img: "/wayside/dogs.jpg",
    bio: "Chief morale officers and full-time fertilizer department. They wouldn't trade this life for the world either.",
  },
];

export default function OurStory() {
  return (
    <div>
      {/* Hero */}
      <section className="relative h-[60vh] min-h-[420px] flex items-end">
        <img src="/wayside/story-hero.jpg" alt="Wayside Orchard" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/30 to-black/20" />
        <div className="relative px-6 md:px-12 lg:px-20 max-w-7xl mx-auto w-full pb-14">
          <p className="kicker text-[#F0D9BF] [text-shadow:0_1px_3px_rgba(0,0,0,0.6)]">Our Story</p>
          <h1 className="font-serif text-5xl sm:text-6xl text-white mt-3 tracking-tight [text-shadow:0_2px_12px_rgba(0,0,0,0.4)]">
            Untroubled.
          </h1>
          <p className="font-serif text-2xl sm:text-3xl text-white/90 mt-2 [text-shadow:0_1px_8px_rgba(0,0,0,0.5)]">
            Unwind from the daily grind.
          </p>
        </div>
      </section>

      {/* Intro */}
      <section className="px-6 md:px-12 lg:px-20 max-w-3xl mx-auto py-20 md:py-28 text-center">
        <p className="kicker">Est. 2019</p>
        <h2 className="font-serif text-4xl sm:text-5xl text-[#2D372B] mt-3 tracking-tight leading-tight">
          Revisiting the livelihood of previous generations.
        </h2>
        <div className="mt-8 space-y-6 text-[#4A5D4E] text-lg leading-relaxed">
          <p>
            Wayside Orchard began in 2019 with a simple belief: that the good things take time, and that food and
            drink made by hand — in small batches, with care — taste the way they were always meant to.
          </p>
          <p>
            We keep bees and gather honey, press and ferment cider from heirloom apples, tap the trees and boil
            maple syrup down the old way, and bottle small-batch fruit wines. Nothing rushed, nothing mass produced —
            just the way things were, and the way we believe they'll be again.
          </p>
        </div>
      </section>

      {/* Quote */}
      <section className="bg-[#2D372B] py-20 md:py-28">
        <div className="px-6 md:px-12 lg:px-20 max-w-4xl mx-auto text-center">
          <blockquote className="font-serif text-3xl sm:text-4xl text-[#FAF8F5] leading-snug italic">
            “The most rewarding part of what we do is being able to see the natural transformation that creates the
            products we gather.”
          </blockquote>
          <p className="font-serif text-2xl text-[#D4A373] mt-8">Jaime &amp; Kylen Blom</p>
          <p className="kicker text-[#A9B3A4] mt-1">Wayside Caretakers</p>
        </div>
      </section>

      {/* Caretakers */}
      <section className="px-6 md:px-12 lg:px-20 max-w-7xl mx-auto py-20 md:py-28">
        <div className="text-center mb-14">
          <p className="kicker">Our Family</p>
          <h2 className="font-serif text-4xl sm:text-5xl text-[#2D372B] mt-2 tracking-tight">Meet Our Caretakers</h2>
          <p className="text-[#4A5D4E] text-lg mt-4">All four of us have a different job — and we wouldn't trade it for the world!</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8" data-testid="caretakers-grid">
          {CARETAKERS.map((c) => (
            <div key={c.name} className="text-center">
              <div className="aspect-square overflow-hidden rounded-sm border border-[#E6DFD3]">
                <img src={c.img} alt={c.name} className="w-full h-full object-cover" />
              </div>
              <h3 className="font-serif text-2xl text-[#2D372B] mt-5">{c.name}</h3>
              <p className="kicker mt-1">{c.role}</p>
              <p className="text-[#4A5D4E] leading-relaxed mt-3 text-sm">{c.bio}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <Link
            to="/shop"
            data-testid="story-shop-button"
            className="inline-flex items-center gap-2 bg-[#B85C38] hover:bg-[#9A4A2B] text-white uppercase tracking-widest text-sm px-8 py-4 transition-colors rounded-sm"
          >
            Explore Our Goods <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
